import Reveal from "@/components/Reveal";
import ThemeTag from "@/components/ThemeTag";

export default function Mission() {
  return (
    <section id="lab">
      <div className="wrap mission">
        <div className="mission-left">
          <Reveal>
            <div className="kicker">Why KOSS 2027 exists</div>
            <h2 className="title">Moving from motivation to mapping.</h2>
            <ThemeTag />
            <div className="callout">
              You can have a brilliant idea and still struggle to make it work. The
              difference is often the plan, the people and the systems behind it.
            </div>
          </Reveal>
          <Reveal delay={0.15} className="frame mission-frame" data-testid="mission-image-frame">
            <img
              src="https://images.unsplash.com/photo-1573164574511-73c773193279?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxBZnJpY2FuJTIweW91bmclMjBwcm9mZXNzaW9uYWxzJTIwYm9hcmRyb29tJTIwc3RyYXRlZ3klMjBtZWV0aW5nJTIwZGlzY3Vzc2lvbiUyMGV4ZWN1dGl2ZXxlbnwwfHx8fDE3OTI1MjgyMzZ8MA&ixlib=rb-4.1.0&q=85"
              alt="Young African professionals in deep strategic discussion around a boardroom table"
              loading="lazy"
            />
            <span className="frame-tag">The Lab · Osogbo</span>
          </Reveal>
        </div>
        <Reveal delay={0.1} className="copy">
          <p>
            Many young people leave university with big plans, but have had few chances
            to practise making difficult decisions with limited time, money, information
            and people. KOSS 2027 is designed to give them that chance.
          </p>
          <p>
            This is not another event where you sit down, listen to speakers and go home
            with notes you may never open again. You will work in small teams, tackle
            realistic business and organisational challenges, make decisions, explain
            your thinking and learn from the process.
          </p>
          <p>
            Led by Dr. Kunle Oparinde, the summit brings together promising young people
            from different backgrounds to test their ideas, learn from one another and
            build practical confidence.
          </p>
          <p className="hint">
            KOSS 2027 — the Kunle Oparinde Strategy Summit — is an initiative of KOS-Lab.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
